// Mock data for portfolio - will be replaced with backend integration

export const personalInfo = {
  name: "Blnd Haval Sardar",
  title: "Software Engineering Student",
  tagline: "Building simple, efficient, and practical software solutions",
  email: "blnd.2007.me@gmail.com",
  emailAlt: "blnd@kuhs.online",
  phone: "07502911007",
  phoneAlt: "07507231952",
  phoneThird: "0787 877 6343",
  linkedin: "https://www.linkedin.com/in/blnd-haval-9a16b737b/",
  location: "Kurdistan, Iraq",
  university: "University of Kurdistan Hewlêr (UKH)"
};

export const aboutContent = {
  intro: "I am a dedicated Software Engineering student at the University of Kurdistan Hewlêr (UKH), pursuing my passion for creating meaningful technological solutions. My journey in software development is driven by a commitment to continuous learning and practical application of programming principles.",
  mission: "My primary focus lies in developing clean, maintainable code and building systems that solve real-world problems. I believe that great software is not just about functionality—it's about creating intuitive, efficient solutions that make a difference in people's lives. Every project I undertake is an opportunity to refine my skills and push the boundaries of what I can create.",
  approach: "I approach software development with a problem-solving mindset, always seeking to understand the core challenges before implementing solutions. My academic background combined with hands-on project experience has equipped me with both theoretical knowledge and practical skills. I am particularly interested in healthcare technology and web development, areas where I see tremendous potential for innovation.",
  goal: "Currently, I am focused on expanding my technical expertise while building a portfolio of meaningful projects. I am actively seeking opportunities to contribute to real-world applications and collaborate with experienced developers to accelerate my growth in the software engineering field."
};

export const skills = [
  {
    category: "Programming Languages",
    items: [
      { name: "Python", level: 85, description: "Backend development, automation, data processing" },
      { name: "JavaScript", level: 75, description: "Frontend development, interactive web applications" },
      { name: "HTML & CSS", level: 80, description: "Responsive web design, modern UI development" }
    ]
  },
  {
    category: "Web Development",
    items: [
      { name: "HTML5", level: 80, description: "Semantic markup, accessibility" },
      { name: "CSS3", level: 80, description: "Flexbox, Grid, responsive design" },
      { name: "JavaScript (ES6+)", level: 75, description: "Modern JavaScript features" },
      { name: "Responsive Design", level: 85, description: "Mobile-first approach" }
    ]
  },
  {
    category: "Tools & Technologies",
    items: [
      { name: "Git & GitHub", level: 80, description: "Version control, collaboration" },
      { name: "Visual Studio Code", level: 90, description: "Primary development environment" },
      { name: "Command Line", level: 70, description: "Bash scripting, system navigation" }
    ]
  },
  {
    category: "Core Competencies",
    items: [
      { name: "Problem Solving", level: 85, description: "Analytical thinking, debugging" },
      { name: "Logical Thinking", level: 85, description: "Algorithm design, optimization" },
      { name: "Software Design", level: 75, description: "Architecture planning, best practices" },
      { name: "Documentation", level: 80, description: "Clear technical writing" }
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "Personal Portfolio Website",
    description: "A fully responsive personal portfolio website designed to showcase my professional profile, technical skills, and project portfolio. This project demonstrates my proficiency in modern web development technologies and responsive design principles.",
    longDescription: "Built from the ground up using semantic HTML5 and modern CSS3 techniques, this portfolio represents my understanding of web standards and best practices. The website features a mobile-first responsive design that adapts seamlessly across all device sizes, ensuring optimal user experience on smartphones, tablets, and desktop computers. I implemented custom CSS animations and transitions to create smooth, engaging interactions while maintaining excellent performance. The project showcases my ability to create clean, maintainable code and my attention to detail in UI/UX design. Every aspect of the site, from the color scheme to the typography, was carefully chosen to create a professional and cohesive brand identity.",
    technologies: ["HTML5", "CSS3", "JavaScript", "Responsive Design", "Git"],
    image: "https://images.unsplash.com/photo-1605379399642-870262d3d051",
    features: [
      "Fully responsive across all devices",
      "Clean, semantic HTML structure",
      "Modern CSS with Flexbox and Grid",
      "Smooth animations and transitions",
      "Optimized performance and loading speed",
      "SEO-friendly markup"
    ],
    status: "Completed",
    year: "2024"
  },
  {
    id: 2,
    title: "Health Center Management System",
    description: "A comprehensive patient management system developed in Python to streamline healthcare operations and improve patient data management. This project addresses real-world challenges in healthcare administration and demonstrates my ability to build practical, scalable solutions.",
    longDescription: "This healthcare management system was designed to solve critical operational challenges faced by medical facilities in managing patient information, appointments, and medical records. Built using Python, the system leverages object-oriented programming principles to create a robust, maintainable codebase. The application features a modular architecture that allows for easy extension and customization based on specific healthcare facility needs. I implemented comprehensive data validation and error handling to ensure data integrity and system reliability. The system includes patient registration, appointment scheduling, medical history tracking, and reporting capabilities. Special attention was paid to data security and privacy, incorporating best practices for handling sensitive medical information. This project is part of a larger initiative to develop a national medical system, and it has provided me with valuable insights into healthcare technology challenges and solutions. The experience has strengthened my understanding of software architecture, database design, and the importance of user-centered design in critical applications.",
    technologies: ["Python", "Object-Oriented Programming", "Data Management", "Algorithm Design"],
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef",
    features: [
      "Patient registration and profile management",
      "Appointment scheduling system",
      "Medical history tracking",
      "Data validation and error handling",
      "Secure data management practices",
      "Reporting and analytics capabilities",
      "Modular, extensible architecture"
    ],
    status: "In Development",
    year: "2024-2025"
  }
];

export const education = {
  degree: "Bachelor of Science in Software Engineering",
  university: "University of Kurdistan Hewlêr (UKH)",
  location: "Erbil, Kurdistan Region, Iraq",
  expectedGraduation: "2029",
  status: "Currently Enrolled",
  gpa: "Maintaining strong academic performance",
  relevantCoursework: [
    "Data Structures and Algorithms",
    "Object-Oriented Programming",
    "Web Development",
    "Database Systems",
    "Software Engineering Principles",
    "Computer Networks",
    "Operating Systems"
  ],
  achievements: [
    "Consistent academic excellence in core programming courses",
    "Active participation in coding projects and practical assignments",
    "Strong foundation in software development fundamentals"
  ],
  description: "Pursuing a comprehensive education in Software Engineering with a focus on practical application and real-world problem-solving. My coursework combines theoretical foundations with hands-on programming experience, preparing me for professional software development challenges."
};

export const experience = {
  current: {
    title: "Software Engineering Student & Developer",
    organization: "University of Kurdistan Hewlêr & Independent Projects",
    period: "2024 - Present",
    description: "Currently engaged in intensive software engineering studies while actively working on practical projects to apply and expand my technical skills. My focus extends beyond academic requirements to include real-world application development and professional skill building.",
    responsibilities: [
      "Developing and maintaining personal and academic software projects with focus on code quality and best practices",
      "Contributing to the development of a national medical system, gaining experience in healthcare technology and large-scale application architecture",
      "Continuously learning new programming languages, frameworks, and development methodologies through online courses and technical documentation",
      "Collaborating with peers on group projects, practicing version control with Git and GitHub for effective team coordination",
      "Conducting code reviews and debugging sessions to improve problem-solving skills and code quality",
      "Documenting development processes and technical decisions to build professional documentation skills",
      "Staying current with industry trends and emerging technologies through technical blogs, forums, and developer communities"
    ]
  },
  nationalMedicalSystem: {
    title: "National Medical System Development",
    role: "Developer Contributor",
    period: "2024 - Present",
    description: "Contributing to the development of a comprehensive national medical system aimed at modernizing healthcare infrastructure. This initiative involves building scalable, secure, and efficient software solutions to manage patient data, streamline healthcare operations, and improve medical service delivery across the region.",
    contributions: [
      "Developing core patient management modules using Python",
      "Implementing data validation and security measures for sensitive medical information",
      "Designing database schemas for efficient data storage and retrieval",
      "Collaborating with healthcare professionals to understand and implement real-world requirements",
      "Testing and debugging system components to ensure reliability and performance"
    ],
    impact: "This project has provided invaluable experience in professional software development, including working with complex requirements, managing large codebases, and understanding the critical importance of security and reliability in healthcare applications."
  }
};

// Mock function to simulate contact form submission
export const submitContactForm = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Simulate success response
  console.log('Form submitted (mock):', formData);
  return {
    success: true,
    message: 'Thank you for your message! I will get back to you soon.'
  };
};
